/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для формы заказа звонка.
   */
  app.ColloristaCallMeFormView = app.CallMeFormView.extend({
    el: '.collorista-call-me',
    formName: '.collorista-form',
    initiatorSelector: '.collorista-button',
    /**
     * Сохранение модели.
     */
    save: function () {
      this.model = new app[this.modelName]();
      this.listenTo(this.model, 'sync', this.success);
      this.listenTo(this.model, 'error', this.error);
      var that = this;
      this.$fields.each(function () {
        that.model.set(this.name, $(this).val());
      });
      this.model.save();
    },
    /**
     * Заполнение ошибок
     * @param {array} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      errors.forEach(function (error) {
        $('.' + error.field + '-error').text(error.message);
        $('[name=' + error.field + ']').addClass('error');
      });
    }
  });
})();


}.call(window));